import React from "react";
import {Editor, ImageSelector} from "components";

const styles = {
  container: {
    padding: '10px 0',
  },
  defaultCursor: {
    cursor: 'default'
  },
  title: {
    fontWeight: 'bold'
  },
  table: {
    width: '100%',
    border: '1px solid',
    borderCollapse: 'collapse',
    boxSizing: 'border-box'
  },
  thead: {
    backgroundColor: 'rgba(0, 0, 0, 0.1)'
  },
  th: {
    textAlign: 'left',
    padding: '2px 8px',
    fontSize: '13px'
  },
  descriptionTitle: {
    marginBottom: '8px'
  },
  center: {
    textAlign: 'center',
  },
  top: {
    verticalAlign: 'top'
  },
  tdTitle: {
    textAlign: 'center',
    height: '1px'
  },
  tdDescription: {
    height: '1px',
    paddingTop: '16px',
    paddingBottom: '16px'
  },
  td: {
    border: '1px solid',
    fontSize: '13px',
    padding: '8px'
  },
  tdImage: {
    width: '30%',
    textAlign: 'center',
    borderRight: 'none'
  },
  tdImgSelector: {
    borderLeft: 'none',
    cursor: 'default'
  }
};

const GagePatternData = (props) => {
  const {imgSrc, product, content, setContent, onImgSelected, removableArea: RemovableArea} = props;
  const designationsText = content?.designation || Object.keys(product.designations || {})
    .reduce((r, v) => r + v + '<br/>', '');
  const resistanceText = content?.resistance || Object.keys(product.designations || {})
    .reduce((r, k) =>
      r + (product.designations[k].resistance || '') + '<br/>', '');
  const optionsText = content?.options || Object.keys(product.designations || {})
    .reduce((r, k) =>
      r + (product.designations[k].options || '') + '<br/>', '');
  const setDesignationContent = (value) => setContent?.('designation', value);
  const setResistanceContent = (value) => setContent?.('resistance', value);
  const setOptionsContent = (value) => setContent?.('options', value);
  const stopPropagation = (e) => e.stopPropagation();

  return (
    <RemovableArea
      data-removable={true}
      id="gagePatternData"
      style={styles.container}
    >
      <table border="1px solid" cellSpacing="0"
             style={styles.table}>
        <thead style={styles.thead}>
        <tr>
          <th colSpan="5" style={styles.th}>
            GAGE PATTERN DATA
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td rowSpan="3" style={{...styles.td, ...styles.tdImage}}>
            <img src={product.imageUrl}/>
          </td>
          <td
            data-removable={true}
            id="actualSize"
            rowSpan="3"
            onMouseOver={stopPropagation}
            onMouseOut={stopPropagation}
            onClick={stopPropagation}
            style={{...styles.td, ...styles.tdImgSelector}}
          >
            <ImageSelector imgSrc={imgSrc} onChange={onImgSelected}/>
          </td>
          <td style={{...styles.td, ...styles.tdTitle}}>
            <span style={styles.title}>GAGE<br/>DESIGNATION</span>
          </td>
          <td style={{...styles.td, ...styles.tdTitle}}>
            <span style={styles.title}>RESISTANCE<br/>(OHMS)</span>
          </td>
          <td style={{...styles.td, ...styles.tdTitle}}>
            <span style={styles.title}>OPTIONS<br/>AVAILABLE</span>
          </td>
        </tr>
        <tr>
          <td
            style={{...styles.td, ...styles.top, ...styles.defaultCursor}}
            onMouseOver={stopPropagation}
            onMouseOut={stopPropagation}
            onClick={stopPropagation}
          >
            <Editor content={designationsText} setContent={setDesignationContent}/>
          </td>
          <td
            style={{
              ...styles.td,
              ...styles.center,
              ...styles.top,
              ...styles.defaultCursor
            }}
            onMouseOver={stopPropagation}
            onMouseOut={stopPropagation}
            onClick={stopPropagation}
          >
            <Editor content={resistanceText} setContent={setResistanceContent}/>
          </td>
          <td
            style={{...styles.td, ...styles.top, ...styles.defaultCursor}}
            onMouseOver={stopPropagation}
            onMouseOut={stopPropagation}
            onClick={stopPropagation}
          >
            <Editor content={optionsText} setContent={setOptionsContent}/>
          </td>
        </tr>
        <tr>
          <td colSpan="3" style={{...styles.td, ...styles.tdDescription}}>
            <div style={styles.descriptionTitle}>
            <span style={styles.title}>
              DESCRIPTION
            </span>
            </div>
            <div>
              {product.description}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </RemovableArea>
  );
};

export default GagePatternData;
